const getCarousel = (state) => state.carouselReducer;
const getListing = (state) => state.listingReducer;
const getListingAvailability = (state) => state.listingAvailabilityReducer;
const getListingExtended = (state) => state.listingExtendedReducer;
const getListingPage = (state) => state.listingPageReducer;
const getSystem = (state) => state.systemReducer;
const getTranslations = (state) => state.translationsReducer;
const getTripData = (state) => state.tripDetailsReducer;
const getReviews = (state) => state.reviewsReducer;
const getGuestSelector = (state) => state.guestSelectorReducer;
const getDatePicker = (state) => state.datePickerReducer;
const getMap = (state) => state.mapReducer;
const getHeader = (state) => state.headerReducer;
const getContactOwnerForm = (state) => state.contactOwnerFormReducer;
const getAbacusTests = (state) => state.abacusTestsReducer;
const getTravelerFeatures = (state) => state.travelerFeaturesReducer;
const getLoggedUser = (state) => state.loginReducer;
const getNavigation = (state) => state.navigationReducer;
const getApplink = (state) => state.applinkReducer;

export {
    getCarousel,
    getListing,
    getListingAvailability,
    getListingExtended,
    getListingPage,
    getSystem,
    getTranslations,
    getTripData,
    getReviews,
    getGuestSelector,
    getDatePicker,
    getMap,
    getHeader,
    getContactOwnerForm,
    getAbacusTests,
    getTravelerFeatures,
    getLoggedUser,
    getNavigation,
    getApplink
};
